import { Box, Loader, Spacer, Text } from '@jfs/ui-new'
import { getRandomAlphaNumString } from '@jfs/utils'
import { useIsFocused } from '@react-navigation/native'
import { useRef, FC, ReactElement, useCallback, useEffect } from 'react'
import { DateSelector } from '../../comps/DateSelection'
import { DropdownOptimised } from '../../comps/DropdownNew'
import { DropdownTypes } from '../../comps/DropdownNew/types'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { SvgImage } from '../../comps/SvgImage'
import Tabbar, { TabbarType } from '../../comps/Tabbar'
import { dateRangeData, insightsWebTabData } from '../../data/static/data'
import { actionMenuStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { DateType, getYesterday } from '../../util/util'
import styles from './styles'
import { TitleSubTitleLayout } from './TitleSubTitleLayout'

const Header: FC = () => {
  const {
    date,
    setNewDate,
    dateValue,
    setDateValue,
    visible,
    top,
    left,
    fetchInsightsSummary,
    summary,
    updateSelectedTab,
    selectedTab,
    mid,
    updateSegmentedVs,
    setMessage,
  } = useStores((root) => ({
    date: root.insights.graphPrefrences.selectedDate,
    setNewDate: root.insights.graphPrefrences.updateDates,
    updateSegmentedVs: root.insights.updateSegmentedVs,
    dateValue: root.insights.graphPrefrences.dateValue,
    setDateValue: root.insights.graphPrefrences.setDateValue,
    visible: root.insights.graphPrefrences.selectedDate.position.visible,
    top: root.insights.graphPrefrences.selectedDate.position.top,
    left: root.insights.graphPrefrences.selectedDate.position.left / 2,
    fetchInsightsSummary: root.insights.fetchInsightsSummary,
    summary: root.insights.getSummary(),
    updateSelectedTab: root.insights.updateSelectedTab,
    selectedTab: root.insights.getSelectedTab(),
    mid: root.user.selectedMid,
    setMessage: root.response?.setMessage,
  }))

  // useEffect(() => {

  //   resetting the date on path change

  //   setDateValue(actionMenuStrings.today)
  //   setNewDate({
  //     fromDate: new Date(),
  //     toDate: new Date(),
  //     position: { ...position, visible: false },
  //   })
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const isFocused = useIsFocused()
  const [fetchInsightsSummaryApi, { state }] = useLazyApiData(fetchInsightsSummary)

  useEffect(() => {
    if (mid) {
      fetchInsightsSummaryApi(mid)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchInsightsSummaryApi, selectedTab, mid])

  const getDateValue = (mValue: number): Date => {
    const today = new Date(Date.now())
    const pastDay = new Date(today.setDate(today.getDate() - mValue))
    pastDay.setMinutes(pastDay.getMinutes() + 1)
    return pastDay
  }

  const getYesterdayValue = useCallback(() => {
    const yesterdayBegin = getYesterday('START')
    const yesterdayEnd = getYesterday('END')
    setNewDate({
      fromDate: yesterdayBegin,
      toDate: yesterdayEnd,
      dateLabel: actionMenuStrings.yesterday,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSelectedDate = (sDate: string): Date => {
    const todayMidnight = new Date(new Date().setHours(0, 0, 0, 0))
    const getSelectedValue = {
      [actionMenuStrings.today]: todayMidnight,
      [actionMenuStrings.lastSeven]: getDateValue(7),
      [actionMenuStrings.customDate]: getDateValue(0),
      [actionMenuStrings.lastFifteen]: getDateValue(15),
      [actionMenuStrings.lastThirty]: getDateValue(30),
      [actionMenuStrings.lastNinty]: getDateValue(90),
    }
    return getSelectedValue[sDate]
  }

  const onDateRangeSelected = (selectedDate: string | number[], pos: any): void => {
    const dateStr = selectedDate.toString()
    const today = new Date(Date.now())

    if (dateStr === actionMenuStrings.yesterday) {
      getYesterdayValue()
    } else {
      const currentDay = dateStr === actionMenuStrings.customDate ? date.toDate : today
      const finishDay =
        dateStr === actionMenuStrings.customDate ? date.fromDate : getSelectedDate(selectedDate.toString())
      setNewDate({
        fromDate: finishDay,
        toDate: currentDay,
        position: { ...pos, visible: dateStr === actionMenuStrings.customDate },
        dateLabel: dateStr !== actionMenuStrings.customDate ? dateStr : actionMenuStrings.customDate,
      })
    }
    if (dateStr !== actionMenuStrings.customDate) {
      setDateValue(dateStr)
      fetchInsightsSummaryApi(mid)
    }
  }

  const onDateSelected = (dateObj: DateType): void => {
    setDateValue(actionMenuStrings.customDate)
    setNewDate({
      fromDate: dateObj.fromDate,
      toDate: dateObj.toDate,
      position: { ...dateObj.position, visible: false },
      dateLabel: actionMenuStrings.customDate,
    })
    fetchInsightsSummaryApi(mid)
  }

  const renderItem = ({ item }: { item: any }): JSX.Element => {
    const getColor: any = {
      '-1': 'BRAND_PRIMARY_RED',
      0: 'BLACK_21',
      1: 'GREEN',
    }

    const selectedDuration =
      new Date(date.toDate.getFullYear(), date.toDate.getMonth(), date.toDate.getDate()).getTime() -
      new Date(date.fromDate.getFullYear(), date.fromDate.getMonth(), date.fromDate.getDate()).getTime()

    const oneday = 24 * 60 * 60 * 1000
    const durationText = Math.abs(selectedDuration / oneday) + 1
    return (
      <Box flexDirection={'column'} pv={4} f={1} key={getRandomAlphaNumString(3)}>
        <TitleSubTitleLayout placeHolder={item.title} title={item.subtitle} formatedVal={item.formatedVal} />
        <Spacer size={12} direction={'vertical'} />
        <ModBox marginLeft={-4} alignContent={'center'} flexDirection={'row'} show={item.margin && item.margin !== 0}>
          <SvgImage imageName={item.margin > 0 ? 'UpArrow' : 'DownArrow'} />
          <Text
            type={'h4'}
            color={'PRIMARY_GREY'}
            numberOfLines={1}
            fontFamily={'jiotype-medium'}
            fontSize={12}
            opacity={item.percentage ? 1 : 0.3}>
            <Text
              fontFamily={'jiotype-bold'}
              fontSize={14}
              color={getColor[item.margin]}
              opacity={item.percentage ? 1 : 0.3}>{`${item.percentage ? `${item.percentage}%` : '_^_'} `}</Text>
            {`${item.margin > 0 ? 'increase' : 'decrease'} in last ${durationText} days`}
          </Text>
        </ModBox>
      </Box>
    )
  }

  const getListView = (): ReactElement[] => {
    return summary.map((item: any) => {
      return renderItem({ item })
    })
  }

  return (
    <>
      <Box flexDirection={'row'}>
        <Box alignItems={'flex-start'}>
          <Tabbar
            default={selectedTab}
            titles={insightsWebTabData()}
            onSelected={(index) => {
              if (index !== selectedTab) {
                updateSegmentedVs('')
                updateSelectedTab(index)
              }
            }}
            type={TabbarType.recentPayments}
          />
        </Box>
        <Spacer direction={'horizontal'} size={24} />
        <Box {...styles.dateContainer}>
          <DropdownOptimised
            placeHolder={dateValue}
            iconType="CALENDAR"
            onChange={onDateRangeSelected}
            data={dateRangeData}
            type={DropdownTypes.DEFAULT_WITH_IMAGE as DropdownTypes}
          />
          <DateSelector
            value={{ fromDate: date.fromDate, toDate: date.toDate, position: { visible, top, left } }}
            onDateSelected={onDateSelected}
            setNewDate={setNewDate}
            isFocused={isFocused}
            maxDuration={31}
            sendError={setMessage}
            defaultMinDate={new Date(new Date().getTime() - 180 * 24 * 60 * 60 * 1000)}
          />
        </Box>
      </Box>
      <Box {...styles.flexRow}>
        {state === 'fulfilled' ? (
          getListView()
        ) : (
          <Box paddingVertical={'BIG'}>
            <Loader color={'BLUE'}/>
          </Box>
        )}
      </Box>
    </>
  )
}

export { Header }
